import styles from "./mandatory-step.module.css";

const MandatoryStep = ({ data = {}, ...properties }) => {
  const {
    step,
    title,
    subtitle,
    illustration,
    button,
    type,
    onClick,
    canPerformAction,
  } = data;
  const isPrimary = type === "primary";

  return (
    <div
      className={`${styles.wrapper} ${
        isPrimary ? styles["primary-wrapper"] : ""
      }`}
      {...properties}
    >
      <header className={styles.header}>
        <p className={styles.step} data-testid="mandatory-step-number">
          {step}
        </p>
        <h2
          className={isPrimary ? styles["primary-text"] : ""}
          data-testid="mandatory-step-title"
        >
          {title}
        </h2>
        <p
          className={isPrimary ? styles["primary-text"] : ""}
          data-testid="mandatory-step-subtitle"
        >
          {subtitle}
        </p>
      </header>
      <div className={styles.illustration}>
        <img src={illustration} alt="illustration" width="100%" />
      </div>
      {canPerformAction && (
        <button
          className={`btn btn--primary ${
            isPrimary ? styles["primary-button"] : ""
          }`}
          onClick={onClick}
          data-testid="mandatory-step-button"
        >
          {button}
        </button>
      )}
    </div>
  );
};

export default MandatoryStep;
